const STEPS = {
    START: "START",
    FORGETME: "FORGETME",
    SUCCESS: "SUCCESS",
  };
  
  export default STEPS;
  